import React from 'react';
import PropTypes from 'prop-types';

export default function SquareCard({
  image,
  toggleLightbox,
  setImageIndex,
  index,
}) {
  return (
    // eslint-disable-next-line
    <div
      className="square-image"
      style={{ backgroundImage: `url('${image}')` }}
      onClick={() => {
        setImageIndex(index);
        toggleLightbox(true);
      }}
    />
  );
}

SquareCard.propTypes = {
  image: PropTypes.string.isRequired,
  toggleLightbox: PropTypes.func.isRequired,
  setImageIndex: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
